import { PageHeader } from "components";
import { NextPage } from "next";
import { ReactNode } from "react";

const Content: React.FC<{
  title: string;
  subtitle: string;
  policy: ReactNode;
}> = ({ policy, title, subtitle }) => {
  return (
    <div className="container">
      <div className="text-center">
        <h2 className="heading-2">{title}</h2>
        <h3 className="lg:text-4xl text-xl lg:my-12 my-8">{subtitle}</h3>
      </div>
      <div className="formHeadings jetsonLinksStyle space-y-6 text-justify">
        {policy}
      </div>
    </div>
  );
};

const policyContent: ReactNode = (
  <>
    <p>
      <strong>1. General information</strong>
    </p>
    <p>
      The owner of the website is Jetson Inc. with its registered seat in the
      State of California, hereinafter referred to as the &quot;Shop&quot;.
    </p>
    <p>
      We respect the right of privacy of the users of the Shop operating by the
      name: Jetson Inc. We adopt organizational and technical measures to
      prevent interfering in the privacy of our users by third parties.
    </p>

    <p>
      <strong>2. Level of protection</strong>
    </p>
    <p>
      Purchases in our Shop are secured with the SSL protocol that is a special
      standard of encrypted data transmission. As part of our Shop&apos;s
      website we place links through which you can reach other websites. While
      using the Shop&apos;s website, in order to improve its functionality,
      through the links provided, Cookies from other service providers, for
      example: Facebook, Twitter, Google, may be placed on your device.
    </p>
    <p>
      The privacy policies and terms of use of Cookies created by the indicated
      entities are beyond the control of the Shop. We recommend that before
      using other websites you read both their privacy policies and terms of use
      of Cookies, in particular:
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>
        Google:{" "}
        <a href="https://policies.google.com/?hl=en">
          https://policies.google.com/?hl=en
        </a>
      </li>
      <li>
        Facebook:{" "}
        <a href="https://www.facebook.com/privacy/explanation">
          https://www.facebook.com/privacy/explanation
        </a>
      </li>
      <li>
        Twitter:{" "}
        <a href="https://twitter.com/en/privacy">
          https://twitter.com/en/privacy
        </a>
      </li>
    </ul>

    <p>
      <strong>3. Collecting data</strong>
    </p>
    <p>
      We log Shop server requests which are recognized by URL addresses and
      which refer to:
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>IP address of the terminal device,</li>
      <li>
        name of the user station if identification is possible by the http
        protocol,
      </li>
      <li>username provided during the authorization process,</li>
      <li>the time of the request,</li>
      <li>the first line of the http request,</li>
      <li>the http answer code, the volume of data sent by the server,</li>
      <li>
        the refer link of the URL address of the previously visited web page if
        a user was directed to the Shop by an internal server,
      </li>
      <li>information about the user&apos;s web browser,</li>
      <li>information about errors during transactions.</li>
    </ul>
    <p>
      The data do not allow for direct identification of persons browsing the
      Shop. Also the Shop does not automatically collect any information except
      for the information contained in cookies.
    </p>

    <p>
      <strong>4. Cookie Policy</strong>
    </p>
    <p>
      Our website uses cookies. Cookies are text files that are stored on a
      user&apos;s terminal device. They usually contain the name of the web page
      which they come from, the duration of their storage and a number.
    </p>
    <p>We use the following types of cookies:</p>
    <ul className="list-disc pl-6 space-y-2">
      <li>
        session cookies - stored on the terminal device until the user logs out
        or quits the Shop,
      </li>
      <li>
        permanent cookies - stored on the terminal device for the time
        determined in their parameters or until the user deletes them,
      </li>
      <li>
        performance cookies - containing information about the way in which the
        Shop is used,
      </li>
      <li>
        necessary cookies - needed for the correct fulfillment of an order,
      </li>
      <li>
        functional cookies - remembering users&apos; settings and personalizing
        the service,
      </li>
      <li>own cookies - placed by the Shop,</li>
      <li>external cookies - coming from a different site than the Shop.</li>
    </ul>
    <p>
      External Cookies files are used for advertising purposes, but only if you
      give your consent. Not granting such consent does not adversely affect the
      functioning of the Shop&apos;s website.
    </p>
    <p>
      These files do not contain information that allow for identification of
      users and do not make it possible to determine users&apos; personal data.
      You can change the scope of data collected by adjusting the settings of
      the web browser which you use. In order to adjust the settings adequately
      to your needs and change the conditions for storing or receiving cookies,
      we recommend selecting the &quot;Help&quot; option of a particular
      browser.
    </p>
    <p>
      More information about cookies can be found on{" "}
      <a href="https://en.wikipedia.org/wiki/HTTP_cookie">
        https://en.wikipedia.org/wiki/HTTP_cookie
      </a>{" "}
      or in the &quot;Help&quot; section in the web browser menu. Every user can
      set the level of privacy and the type of cookies.
    </p>
    <p>
      The Shop uses cookies to collect information concerning the use of the
      Shop by the Users. Cookies enable in particular:
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>
        maintaining the User&apos;s session (after logging in), therefore the
        User is not required to enter the login and password again on every
        subpage of the Shop,
      </li>
      <li>
        adjusting the Shop to the Users&apos; needs, creating viewing statistics
        and analysis of the Shop&apos;s website,
      </li>
      <li>adjusting advertising content to the User&apos;s preferences,</li>
      <li>
        verifying the User&apos;s activity on the website, including determining
        whether the User is not a robot - as part of the reCAPTCHA mechanism
        provided by Google.
      </li>
    </ul>

    <p>
      <strong>5. Do Not Track</strong>
    </p>
    <p>
      Do not track is a feature offered by some browsers, with some newer
      browsers offering it as default. If you enable it, it sends a signal to
      websites to request that your browsing not be tracked, for example by
      third party ad or social networks, or by analytics companies. You can opt
      out of tracking and analytics on this website by changing your settings
      within your browser.
    </p>
    <p>
      At present, no industry-wide uniform standard has been agreed and adopted
      to determine how DNT requests should be managed, so our website does not
      currently respond to DNT requests.
    </p>
    <p>
      For more information on our cookies policy or any data protection related
      questions please contact us on privacy@jetson.com.
    </p>
  </>
);

const CookiesPolicy: NextPage = () => {
  return (
    <div className="bg-white py-section">
      <PageHeader title="Cookies Policy" />
      <Content
        policy={policyContent}
        subtitle="Jetson Inc."
        title="Cookies Policy"
      />
    </div>
  );
};
export default CookiesPolicy;
